<template>
  <div :class="$options.name">
  </div>
</template>

<script>
import * as d3 from 'd3'
import * as _ from 'lodash'

export default {
  name: 'interactives-d3-svg',
  props: {
    margins: {
      type: Object,
      default: function () {
        return {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    },
    debounce: {
      type: [Number, String],
      default: 500
    }
  },
  mounted () {
    this.setUp()
  },
  methods: {
    setUp () {
      this.el = d3.select(this.$el)
      this.svgWidth = this.$el.clientWidth
      this.svgHeight = this.$el.clientHeight
      this.vizWidth = this.svgWidth - (this.margins.right + this.margins.left)
      this.vizHeight = this.svgHeight - (this.margins.top + this.margins.bottom)

      this.svg = this.el.append('svg')
        .attr('class', `${this.el.attr('class')}-svg`)
        .attr('width', this.svgWidth)
        .attr('height', this.svgHeight)

      this.viz = this.svg.append('g')
        .attr('class', `${this.el.attr('class')}-viz`)
        .attr('transform', `translate(${this.margins.left}, ${this.margins.top})`)

      this.$on('ready', function () {
        this.renderViz()
        this.$el.addEventListener('resize', _.debounce(this.resizeViz, this.debounce))
      })
    },
    // to be defined by components that extend this one
    renderViz () { },
    resizeViz () { }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?14d75b8d